import { tv } from 'tailwind-variants'

export const labelBadgeVariants = tv({
  base: [
    'flex items-center justify-center',
    'w-[92px] h-[30px]',
    'text-center text-base uppercase font-formula font-bold [text-shadow:0px_1px_1px_rgba(0,0,0,0.25)]',
    'rounded-b-10'
  ],
  variants: {
    active: {
      true: '',
      false: ['bg-glass-overlay']
    },
    accentColor: {
      none: '',
      yellow: '',
      green: '',
      blue: ''
    }
  },
  defaultVariants: {
    active: false,
    accentColor: 'yellow'
  },
  compoundVariants: [
    {
      active: true,
      accentColor: 'yellow',
      class: ['shadow-yellow-top-accent-inset bg-yellow-gradient']
    },
    {
      active: true,
      accentColor: 'green',
      class: ['shadow-green-top-accent-inset bg-green-gradient']
    },
    {
      active: true,
      accentColor: 'blue',
      class: ['shadow-blue-top-accent-inset bg-blue-gradient']
    },
    {
      active: true,
      accentColor: 'none',
      class: ['bg-glass-overlay']
    }
  ]
})

export const LabelBadgeTextVariants = tv({
  variants: {
    active: {
      true: ['text-white'],
      false: ['txt-gradient-frost']
    },
    accentColor: {
      none: '',
      yellow: '',
      green: '',
      blue: ''
    }
  },
  defaultVariants: {
    active: false,
    accentColor: 'yellow'
  }
})
